import React from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  Box,
} from '@material-ui/core';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

const WrapperApiRequestCard = ({ wrapperRequest, classes }) => {
  if (!wrapperRequest) return null;

  const renderSearchCriteria = () => {
    const rawSearchCriteria =
      wrapperRequest?.dataJson?.SearchCriteria ||
      wrapperRequest?.dataJson?.searchCriteria;

    if (!Array.isArray(rawSearchCriteria) || rawSearchCriteria.length === 0) {
      return null;
    }

    const sortedSearchCriteria = [...rawSearchCriteria].sort(
      (a, b) => (a?.Priority ?? a?.priority ?? 0) - (b?.Priority ?? b?.priority ?? 0)
    );

    return sortedSearchCriteria.map((criteria, index) => {
      const memberInfo = criteria?.MemberInfo || criteria?.memberInfo;
      const vehicleInfo = criteria?.VehicleInfo || criteria?.vehicleInfo;
      const vinInfo = vehicleInfo?.Vin || vehicleInfo?.vin;
      const priority = criteria?.Priority ?? criteria?.priority;
      const validationName = criteria?.ValidationName || criteria?.validationName;

      return (
        <Box key={`criteria-${index}`} sx={{ mb: 2 }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
            <strong>{validationName}</strong> (Priority: {priority})
          </Typography>
          {memberInfo && Object.entries(memberInfo).some(([_, v]) => v !== null) && (
            <Box sx={{ ml: 2, mb: 1 }}>
              <Typography variant="caption" color="textSecondary">Member Info:</Typography>
              {Object.entries(memberInfo).map(([key, value]) =>
                value !== null ? (
                  <Typography key={key} variant="body2" sx={{ ml: 1 }}>
                    {key}: {value}
                  </Typography>
                ) : null
              )}
            </Box>
          )}
          {vehicleInfo && (Object.values(vinInfo || {}).some(v => v !== null) || vehicleInfo.Plate || vehicleInfo.plate) && (
            <Box sx={{ ml: 2 }}>
              <Typography variant="caption" color="textSecondary">Vehicle Info:</Typography>
              {(vinInfo?.Vin8 || vinInfo?.vin8) && (
                <Typography variant="body2" sx={{ ml: 1 }}>
                  Vin8: {vinInfo?.Vin8 || vinInfo?.vin8}
                </Typography>
              )}
              {(vinInfo?.FullVin || vinInfo?.fullVin) && (
                <Typography variant="body2" sx={{ ml: 1 }}>
                  FullVin: {vinInfo?.FullVin || vinInfo?.fullVin}
                </Typography>
              )}
              {(vehicleInfo.Plate || vehicleInfo.plate) && (
                <Typography variant="body2" sx={{ ml: 1 }}>
                  Plate: {vehicleInfo.Plate || vehicleInfo.plate}
                </Typography>
              )}
            </Box>
          )}
        </Box>
      );
    });
  };

  return (
    <Card variant="outlined" style={{ marginBottom: "20px", width: "100%" }}>
      <CardHeader
        title="Request to Wrapper API"
        avatar={<ArrowForwardIcon />}
        className={classes.logSearchDialogHeader}
      />
      <CardContent>
        {renderSearchCriteria()}
        {wrapperRequest?.dataJson?.memberInfo && (
          <Box sx={{ mt: 1 }}>
            <Typography variant="caption" color="textSecondary">Member Info:</Typography>
            {typeof wrapperRequest.dataJson.memberInfo === 'object'
              ? Object.entries(wrapperRequest.dataJson.memberInfo).map(([key, value]) =>
                  value !== null && value !== undefined ? (
                    <Typography key={key} variant="body2" sx={{ ml: 1 }}>
                      {key}: {String(value)}
                    </Typography>
                  ) : null
                )
              : <Typography variant="body2" sx={{ ml: 1 }}>
                  {wrapperRequest.dataJson.memberInfo}
                </Typography>
            }
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

WrapperApiRequestCard.propTypes = {
  wrapperRequest: PropTypes.object,
  classes: PropTypes.object.isRequired,
};

export default WrapperApiRequestCard;
